export default {
  "rowSelection": false,
  "name": "constructManage",
  "columns": [
    {
      "title": "线索ID",
      "dataIndex": "clueId",
      "width": 150,
      "fixed": "left",
      "render": "idJump"
    },
    {
      "title": "营销人员",
      "width": 150,
      "dataIndex": "agentName"
    },
    {
      "title": "通话时长",
      "dataIndex": "callTimeLength",
      "width": 150
    },
    {
      "title": "IP归属地",
      "dataIndex": "address",
      "width": 150,
    },
    {
      "title": "通话合格",
      "dataIndex": "conformity",
      "width": 150,
    },
    {
      "title": "呼叫时间",
      "dataIndex": "ring",
      "itemType": "dateTime",
      "width": 180
    },
    {
      "title": "呼叫类型",
      "dataIndex": "callTypeName",
      "width": 150,
    },
    {
      "title": "接听状态",
      "dataIndex": "callStateName",
      "width": 150,
      // render:"callStateName"
    },
    {
      "title": "操作",
      "dataIndex": "bindType",
      "width": 180,
      "render": "operation",
      "fixed": "right"
    }
  ],
  "search": [
    {
      "name": "clueIdOrPhone",
      "placeholder": "请输入线索ID、客户号码",
      "label": "搜索查询"
    },
    {
      "name": "callType",
      "label": "呼叫类型",
      "itemType": "select",
      "data": "callTypeList",
      "labelKey": "description"
    },
    {
      "name": "state",
      "label": "接听状态",
      "itemType": "select",
      "data": "answerState",
      "labelKey": "description"
    },
    {
      "name": "isConformity",
      "label": "通话合格",
      "itemType": "select",
      "data": "callQualifiedList"
    },
    {
      "name": "callTime",
      "label": "呼叫时间",
      "itemType": "autoDate",
      "showTime":true,
      // "render": "callTiem"
    },
    // {
    //   "name": "seatIdValue",
    //   "label": "派单坐席",
    //   "itemType": "select",
    //   "labelKey": "name",
    //   "key": "workNumber",
    //   "data": "sendOrdersSeats"
    // },
    {
      "name": "duration",
      "label": "通话时长",
      "itemType": "custom",
      "render": "duration"
    }
  ],
  "footer": [
    // {
    //   "label": "导出",
    //   // "auth": "btn.icrm.member.user.ration",
    //   "ghost": true,
    //   "type": "primary",
    //   "status": ["loading:exportLoading"],
    //   "events": ["onClick:onExport"]
    // }
  ]
}
